import SODUrlBuilder from '@scout24/cxp-scale-on-demand';
function changeImage(resize, imageUrl, width, height) {
  var format = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'jpeg';
  var quality = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 70;
  if (imageUrl.includes('www.static-immobilienscout24.de/statpic')) {
    return imageUrl;
  }
  if (imageUrl && imageUrl.length > 0) {
    if (resize) {
      return SODUrlBuilder.of(imageUrl).resize(width, height, '>').quality(quality).format(format).build();
    }
    return SODUrlBuilder.of(imageUrl).legacyThumbnail(width, height, '>').quality(quality).format(format).build();
  }
  return '';
}
export function resizeImage(imageUrl, width, height) {
  var format = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'jpeg';
  var quality = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 70;
  return changeImage(true, imageUrl, width, height, format, quality);
}
export function cropAndResizeImage(imageUrl, width, height) {
  var format = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'jpeg';
  var quality = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 70;
  return changeImage(false, imageUrl, width, height, format, quality);
}